import { Divider } from '@mui/material';
import React, { useEffect } from 'react';

import MainLayout from '../../layoutV2/MainLayout';
import TopSec from './TopSec';
import { usePageTitleStore } from '../../store/PageTitleStore';

const GetQuote = () => {
  const { updateTitle } = usePageTitleStore();

  useEffect(() => {
    updateTitle('Get Quotes');
  }, []);

  return (
    <MainLayout>
      <TopSec startLink={'/start2'} openForm={true} />
      <Divider />
    </MainLayout>
  );
};

export default GetQuote;
